const normalizeWords = (value = "") =>
  String(value || "")
    .trim()
    .split(/\s+/)
    .map((word) => word.replace(/[^a-z0-9]/gi, ""))
    .filter(Boolean);

export const buildCustomerCode = (customerName = "") => {
  const words = normalizeWords(customerName);

  if (words.length === 0) {
    return "GEN";
  }

  const [firstWord, ...restWords] = words;
  let code = firstWord.length <= 2
    ? firstWord.toUpperCase()
    : firstWord.slice(0, 2).toUpperCase();

  for (const word of restWords) {
    if (code.length >= 3) {
      break;
    }

    code += word.charAt(0).toUpperCase();
  }

  if (code.length < 3 && firstWord.length > code.length) {
    code = firstWord.slice(0, Math.min(3, firstWord.length)).toUpperCase();
  }

  return code || "GEN";
};

export const buildComplaintIdPreview = (count = 0, dateValue = new Date(), customerCode = "000") => {
  const date = Number.isNaN(new Date(dateValue).getTime()) ? new Date() : new Date(dateValue);
  const yr = String(date.getFullYear()).slice(-2);
  const month = String(date.getMonth() + 1);
  const monthYear = `${month}${yr}`;
  return `C${monthYear}/${customerCode}-${Number(count) + 1}`;
};

export const buildTestCertificateNumber = (customerName, visitDate, index) => {
  const parsed = visitDate ? new Date(visitDate) : new Date();
  const safeDate = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
  const year = String(safeDate.getFullYear()).slice(-2);
  const month = String(safeDate.getMonth() + 1).padStart(2, "0");
  const sequence = String(index + 1).padStart(2, "0");
  return `GEN/${buildCustomerCode(customerName)}/${year}${month}/${sequence}`;
};

export const DEFAULT_TEST_CERTIFICATE_SETTINGS = {
  prefix: "GEN",
  startingRunningNumber: 1,
  monthCodes: {
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "A",
    "11": "B",
    "12": "C"
  },
  materialCodes: {
    acb: "A",
    vcb: "B",
    mccb: "C",
    other: "D"
  }
};

const resolveMaterialKey = (product = {}) => {
  const source = String(
    product?.materialKey ||
    product?.productName ||
    product?.product ||
    product?.category ||
    ""
  ).trim().toLowerCase();

  if (source.includes("vcb")) return "vcb";
  if (source.includes("mccb")) return "mccb";
  if (source.includes("acb")) return "acb";
  return "other";
};

export const buildTestCertificatePreview = (product, visitDate, settings = DEFAULT_TEST_CERTIFICATE_SETTINGS) => {
  const parsed = visitDate ? new Date(visitDate) : new Date();
  const safeDate = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
  const yearCode = String(safeDate.getFullYear()).slice(-2);
  const monthKey = String(safeDate.getMonth() + 1);
  const materialKey = resolveMaterialKey(product);
  const monthCode = settings?.monthCodes?.[monthKey] || DEFAULT_TEST_CERTIFICATE_SETTINGS.monthCodes[monthKey] || monthKey;
  const materialCode = settings?.materialCodes?.[materialKey] || DEFAULT_TEST_CERTIFICATE_SETTINGS.materialCodes[materialKey] || "D";
  const prefix = String(settings?.prefix || DEFAULT_TEST_CERTIFICATE_SETTINGS.prefix).trim() || "GEN";

  return `${prefix}/${yearCode}/${monthCode}/${materialCode}/----`;
};
